import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Send } from 'lucide-react';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const handleClose = () => {
    onClose();
    setTimeout(() => {
      setFullName('');
      setEmail('');
      setDescription('');
      setSubmitted(false);
    }, 300);
  };
  return <AnimatePresence data-id="element-95">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center px-4" data-id="element-96">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={handleClose} data-id="element-97" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.4,
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="relative w-full max-w-md bg-brown-700 rounded-3xl shadow-2xl overflow-hidden border border-white/10" data-id="element-98">
            <div className="h-1.5 bg-gradient-to-r from-accent-purple to-accent-pink" data-id="element-99" />

            <button onClick={handleClose} className="absolute top-5 right-5 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors text-cream-400 hover:text-white" data-id="element-100">
              <X size={16} data-id="element-101" />
            </button>

            <div className="p-8 md:p-10" data-id="element-102">
              {!submitted ? <>
                  <div className="mb-8" data-id="element-103">
                    <h2 className="text-3xl font-serif italic text-white mb-2" data-id="element-104">
                      Get in Touch
                    </h2>
                    <p className="text-cream-400 text-sm leading-relaxed" data-id="element-105">
                      Have a question or need help? We'd love to hear from you.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-5" data-id="element-106">
                    <div data-id="element-107">
                      <label className="block text-xs font-bold text-cream-400 uppercase tracking-wider mb-2" data-id="element-108">
                        Full Name
                      </label>
                      <input type="text" value={fullName} onChange={e => setFullName(e.target.value)} required placeholder="Sarah Johnson" className="w-full bg-brown-800 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-cream-500 focus:outline-none focus:border-accent-pink focus:ring-1 focus:ring-accent-pink/50 transition-all text-sm" data-id="element-109" />
                    </div>

                    <div data-id="element-110">
                      <label className="block text-xs font-bold text-cream-400 uppercase tracking-wider mb-2" data-id="element-111">
                        Email
                      </label>
                      <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="sarah@example.com" className="w-full bg-brown-800 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-cream-500 focus:outline-none focus:border-accent-pink focus:ring-1 focus:ring-accent-pink/50 transition-all text-sm" data-id="element-112" />
                    </div>

                    <div data-id="element-113">
                      <label className="block text-xs font-bold text-cream-400 uppercase tracking-wider mb-2" data-id="element-114">
                        Description
                      </label>
                      <textarea value={description} onChange={e => setDescription(e.target.value)} required placeholder="Tell us how we can help..." rows={4} className="w-full bg-brown-800 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-cream-500 focus:outline-none focus:border-accent-pink focus:ring-1 focus:ring-accent-pink/50 transition-all text-sm resize-none" data-id="element-115" />
                    </div>

                    <button type="submit" className="w-full bg-gradient-to-r from-accent-purple to-accent-pink text-white text-sm font-bold tracking-widest uppercase px-6 py-4 rounded-full hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center justify-center space-x-2 group mt-2" data-id="element-116">
                      <span data-id="element-117">Send Message</span>
                      <Send className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-118" />
                    </button>
                  </form>
                </> : <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="text-center py-8" data-id="element-119">
                  <div className="w-16 h-16 rounded-full bg-accent-purple/20 flex items-center justify-center mx-auto mb-6" data-id="element-120">
                    <motion.div initial={{
                scale: 0
              }} animate={{
                scale: 1
              }} transition={{
                delay: 0.2,
                type: 'spring',
                stiffness: 200
              }} className="text-accent-purple text-3xl" data-id="element-121">
                      ✓
                    </motion.div>
                  </div>
                  <h3 className="text-2xl font-serif italic text-white mb-3" data-id="element-122">
                    Message Sent!
                  </h3>
                  <p className="text-cream-400 text-sm leading-relaxed mb-6" data-id="element-123">
                    Thanks, {fullName.split(' ')[0]}! We'll get back to you as
                    soon as possible.
                  </p>
                  <button onClick={handleClose} className="text-accent-pink text-sm font-bold uppercase tracking-widest hover:text-white transition-colors" data-id="element-124">
                    Close
                  </button>
                </motion.div>}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}